"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverFaqRole = void 0;
var DriverFaqRole;
(function (DriverFaqRole) {
    DriverFaqRole["Driver"] = "driver";
    DriverFaqRole["DriversCompany"] = "driversCompany";
    DriverFaqRole["DriversCompanyDriver"] = "driversCompanyDriver";
})(DriverFaqRole || (exports.DriverFaqRole = DriverFaqRole = {}));
//# sourceMappingURL=driver-faq-role.enum.js.map